import { render, staticRenderFns } from "./workerControl.vue?vue&type=template&id=20d372c0&scoped=true"
import script from "./workerControl.vue?vue&type=script&lang=js"
export * from "./workerControl.vue?vue&type=script&lang=js"
import style0 from "./workerControl.vue?vue&type=style&index=0&id=20d372c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d372c0",
  null
  
)

export default component.exports